export const colors = {
  primary: '#0D3549',
  white: '#FFFFFF',
  orange: '#E47515',
  dashboard: '#E5E5E5',
  blue: '#0D3549',
  blueLight: '#1271EE',
  green: '#24A95D',
  greenLight: '#ADE84F',
  greenDark: '#197641',
  greenDark2: '#1B8046',
  gray: '#828282',
  grayLight: '#BDBDBD',
  grayLight4: '#F1F4F5',
  gray1: '##2D3A40',
  gray4: '#B2BBBF',
  gray5: '#F1F4F5',
  gray7: '#6D787D',
  lightGrey: '#D7DDE0',
  graylightest: '#9e9e9e',
  grayDark: '#3E3E3E',
  grayExtraLight: '#F2F2F2',
  red: '#ED1C24',
  redLight: '#E87070',
  stepInactive: '#E0E0E0',
  stepActive: '#FFF8D2',
  lightBlue: '#1271EE',
  black: '#000000',
  red2: '#D42929',
  yellow: '#EBAC00',
  neutral: '#FAFAFA',
  warning: '#EBAC00',
}
